import React from "react";
import { ReactComponent as PartnerFit2FlyLogo } from "../images/partners/fit2fly.svg";

const PARTNERS = {
  fit2fly: {
    logo: height => <PartnerFit2FlyLogo style={{ height }} />,
    whitelabel: true
  }
};

export { PARTNERS };
